import type { ShipType } from '@stars-and-ships/api-types';
import { useCodex } from '../../api/queries';
import { formatRate, SHIP_TEXT } from '../../codex';
import { formatDuration, formatNumber, SHIP_LABELS } from '../../labels';
import { ErrorNotice, Sheet, Spinner } from '../ui';

const LINE_LABELS = { front: 'Front', mid: 'Mid', back: 'Back', none: 'None (does not fight)' };

export function ShipInfo({
  galaxyId,
  ship,
  open,
  onClose,
}: {
  galaxyId: string;
  ship: ShipType;
  open: boolean;
  onClose(): void;
}) {
  const codex = useCodex(galaxyId);
  const entry = codex.data?.ships.find((s) => s.type === ship);
  const rows: [string, string][] = entry
    ? [
        ['Line', LINE_LABELS[entry.line]],
        ['Attack', formatRate(entry.attack)],
        ['Defense', formatRate(entry.defense)],
        ['Hull', formatRate(entry.hull)],
        ['Speed (ly/h)', formatRate(entry.speedLyph)],
        ['Cargo', formatNumber(entry.cargo)],
        ['Habitat points', formatNumber(entry.habitatPoints)],
        ['Space Dock level', formatNumber(entry.dockLevel)],
        [
          'Cost (M / G / S)',
          `${formatNumber(entry.cost.metal)} / ${formatNumber(entry.cost.gas)} / ${formatNumber(entry.cost.supplies)}`,
        ],
        ['Build time (Space Dock Lv 1)', formatDuration(entry.buildDurationMs)],
      ]
    : [];
  return (
    <Sheet open={open} title={SHIP_LABELS[ship]} onClose={onClose}>
      {codex.isPending ? <Spinner /> : null}
      {codex.error ? <ErrorNotice error={codex.error} /> : null}
      <p className="text-sm text-text">{SHIP_TEXT[ship]}</p>
      {entry ? (
        <dl className="mt-3 space-y-1 text-sm">
          {rows.map(([name, value]) => (
            <div key={name} className="flex justify-between gap-3">
              <dt className="text-muted">{name}</dt>
              <dd className="font-mono tabular-nums text-text">{value}</dd>
            </div>
          ))}
        </dl>
      ) : null}
    </Sheet>
  );
}
